import React from "react";

/**
 * Carte KPI simple
 * Affiche label, value, subvalue optionnel
 * Null-safe : affiche "—" si valeur absente
 */
export default function KpiCard({ label, value, subvalue, className = "" }) {
  const displayValue = value !== null && value !== undefined ? value : "—";

  return (
    <div className={`bg-white rounded-xl shadow-sm border p-4 ${className}`}>
      <div className="text-sm text-gray-500 mb-1">{label}</div>
      <div className="text-2xl font-bold text-gray-900">{displayValue}</div>
      {subvalue && <div className="text-xs text-gray-500 mt-2">{subvalue}</div>}
    </div>
  );
}
